import { ErrorResponse } from '~/infra/ErrorResponse';
export const isTransientError = (error)=>{
    const status = new ErrorResponse(error).status;
    return status == null || status >= 500;
};
